/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserGachaMintedOutOfResponse } from '../../models/get-user-gacha-minted-out-of-response';
import { UserServiceGetUserGachaDatesRequest } from '../../models/user-service-get-user-gacha-dates-request';

export interface UserServiceGetUserGachaMintedOutOf$Params {
  userUuid: string;
      body: UserServiceGetUserGachaDatesRequest
}

export function userServiceGetUserGachaMintedOutOf(http: HttpClient, rootUrl: string, params: UserServiceGetUserGachaMintedOutOf$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserGachaMintedOutOfResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUserGachaMintedOutOf.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserGachaMintedOutOfResponse>;
    })
  );
}

userServiceGetUserGachaMintedOutOf.PATH = '/api/v3/gateway/user/{userUuid}/gacha/minted';
